import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../lib/auth_store';
import { useIdleTimer } from '../lib/idle_timer';
import { toast } from 'sonner';

interface ProtectedRouteProps {
  requiredRole?: string;
}

export function ProtectedRoute({ requiredRole }: ProtectedRouteProps) {
  const { isAuthenticated, user, logout } = useAuthStore();

  useIdleTimer(async () => {
    await logout();
    toast.info('Your session has expired. Please sign in again.');
  });

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && user?.role !== requiredRole && user?.role !== 'admin') {
    return <Navigate to="/denials" replace />;
  }

  return <Outlet />;
}
